import JassEventId from './eventid';

/**
 * type playerevent
 */
export default class JassPlayerEvent extends JassEventId {}
